export default __webpack_public_path__ + "static/media/book.a60fb248.svg";